import { useNode, useEditor } from "@craftjs/core";
import React from "react";
import { StarRatingSettings } from "./settings";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faStar } from "@fortawesome/free-solid-svg-icons";
import GrigoraCSSRenderer from "./../css-render";
import icon from "./icon";
import { CMSStarRatingSettings } from "./cms-settings";
import classnames from "classnames";
import { getDynamicCSS, getSupportProps } from "../../block-supports";
import CMSIcon from "./cms-icon";

export const StarRating = (props) => {
  const {
    id,
    connectors: { connect, drag },
  } = useNode((state) => ({
    id: state.id,
    selected: state.events.selected,
    dragged: state.events.dragged,
  }));

  const {
    actions: { selectNode },
  } = useEditor();

  const { totalStars = 5, rating = 3, suffix, prefix } = props;

  var blockProps = getSupportProps({
    id,
    ...props,
  });

  const wrapperClass = classnames(
    {
      "g-star-rating": true,
      [`star-rating-${id}`]: id,
    },
    blockProps.className,
  );

  return (
    <div
      {...blockProps}
      ref={(ref) => connect(drag(ref))}
      className={wrapperClass}
      onFocus={() => {
        selectNode(id);
      }}
      data-grigora-block="true"
      data-grigora-block-id={id}
    >
      <style>{`${getDynamicCSS(id, props)}`}</style>
      <style>{`${GrigoraCSSRenderer.blockCSS__StarRating(id, props)}`}</style>

      <div className="star-rating-container">
        {prefix && <label>{prefix}</label>}

        {[...Array(totalStars)].map((star, index) => {
          return (
            <span key={`star-${index}`} className="star">
              <FontAwesomeIcon
                key={index}
                className={`star-icon ${index < rating ? "on" : ""}`}
                icon={faStar}
              />
            </span>
          );
        })}

        {suffix && <label>{suffix}</label>}
      </div>
    </div>
  );
};

// To Avoid Mangling in Production
StarRating.displayName = "StarRating";

StarRating.craft = {
  name: "Star Rating",
  props: {},
  related: {
    CMSsettings: CMSStarRatingSettings,
    settings: StarRatingSettings,
    CMSIcon: CMSIcon,
    supports: [
      "grigora/entrance-animations",
      "grigora/css-transform-animations",
      "grigora/mouse-movement",
      "grigora/visibility",
      "grigora/position",
      "grigora/sticky",
      "grigora/filter",
      "grigora/custom-class",
      "grigora/custom-id",
    ],
    icon: icon,
    keywords: ["Star Rating", "Rating"],
  },
  custom: {
    name: "Star Rating",
    slug: "grigora/star-rating",
  },
};
